<template>
  <div id="contenedor-main-estimaciones-reporte-concentrado" class="white rounded-xl">
    <div id="generales-contratos" class="pa-5 text-uppercase">
      <v-row>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATO:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.numero }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              CONTRATISTA:
            </v-col>
            <v-col
              cols="6">
              {{ contrato.contratista.nombreRazonSocial }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              FORMULADA EL:
            </v-col>
            <v-col
              cols="6">
              {{ estimacion.fechaAutorizacion }}
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              PERIODO DEL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${estimacion.fechaDel} 00:00:00`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="4">
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              ESTIMACIÓN NO.
            </v-col>
            <v-col
              cols="6">
              <v-chip
                color="base4">
                {{ estimacion.numero }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row
            no-gutters>
            <v-col
              cols="6"
              class="font-weight-bold">
              AL:
            </v-col>
            <v-col
              cols="6">
              {{ new Date(`${estimacion.fechaAl} 00:00:00`)
                .toLocaleDateString('es-MX', { year: 'numeric',
                    month: 'long', day: 'numeric' }) }}
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row
            no-gutters>
            <v-col>
              <span class="font-weight-bold text-uppercase">
                Fecha presentación
              </span>
            </v-col>
            <v-col>
              {{ new Date(`${estimacion.fechaPresentacion}T00:00:0Z`).toLocaleDateString() }}
            </v-col>
            <v-col>
              <span class="font-weight-bold text-uppercase">
                Fecha autorización
              </span>
            </v-col>
            <v-col>
              {{ new Date(`${estimacion.fechaAutorizacion}T00:00:0Z`).toLocaleDateString() }}
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12">
          <v-subheader>
            OBSERVACIONES
          </v-subheader>
          <span>
            {{ estimacion.observaciones }}
          </span>
        </v-col>
      </v-row>
    </div>
    <div id="detalles-tipos-trabajos">
      <v-simple-table>
        <template
          v-slot:default>
          <thead
            class="base4">
            <tr>
              <th class="text-center" width="100">HOJA DE DETALLE</th>
              <th>TIPO DE TRABAJO</th>
              <th class="text-right" width="200">IMPORTE</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="({ concepto, importe }, index) in listadoConcentrado">
              <tr
                :key="`concepto-${index}`">
                <td
                  class="text-center">
                  {{ (index + 1) }}
                </td>
                <td>
                  {{ concepto }}
                </td>
                <td class="text-right">
                  {{ importe | currency }}
                </td>
              </tr>
            </template>
          </tbody>
          <tfoot class="font-weight-bold">
            <tr>
              <td colspan="2" class="text-right">SUMA</td>
              <td class="text-right">
                {{ estimacion.importeCostoDirecto | currency }}
              </td>
            </tr>
          </tfoot>
        </template>
      </v-simple-table>
    </div>
    <v-row
      justify="space-between">
      <v-col
        cols="4">
        <div id="liquidacion">
          <estimacion-liquidacion
            :estimacion="estimacion"
            :esObraFinanciada="contrato.esObraFinanciada"
            :contrato="contrato"
            mostrar-detalle-estimado-opf>
          </estimacion-liquidacion>
        </div>
      </v-col>
      <v-col
        cols="3">
        <firma
          class="mb-5"
          titulo="FORMULÓ"
          :nombre="contrato.contratista.nombreRazonSocial"
          :sub-nombre="contrato.contratista.nombreRepresentante"
          mostrar-linea
          key="contratista">
        </firma>
        <firma
          v-if="getContratoSupervisionExternaEnConcentrado"
          :nombre="getContratoSupervisionExternaEnConcentrado
          .contratoRelacionado.contratista.nombreRazonSocial"
          sub-nombre="Supervisión externa"
          key="supervisionExterna">
        </firma>
        <firma
          v-if="getSupervisorEnConcentrado"
          titulo="REVISÓ"
          :nombre="getSupervisorEnConcentrado.funcionario.nombre"
          sub-nombre="supervisor de obra"
          mostrar-linea
          key="supervisor">
        </firma>
      </v-col>
      <v-col
        cols="3">
        <template
          v-for="firma in getFirmasActualizadas">
          <firma
            :key="firma.id"
            titulo="APROBÓ"
            class="mb-5"
            :nombre="firma.funcionario.nombre"
            :sub-nombre="firma.funcionario.puesto"
            mostrar-linea>
          </firma>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// import RESUMEN_CONCEPTOS_PORNIVEL
// from '@/graphql/querys/administracion/ejecucion/estimaciones/resumenConceptosPorNivel.gql';
import EstimacionLiquidacion from '@/components/administracion/ejecucion/estimaciones/reportes/Liquidacion.vue';
import Firma from '@/components/Firma.vue';
import mixDescargaConcentradoEstimaciones from './mixDescargaConcentradoEstimaciones';

export default {
  name: 'MainEstimacionesReportesConcentrado',
  components: {
    EstimacionLiquidacion,
    Firma,
  },
  mixins: [
    mixDescargaConcentradoEstimaciones],
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {};
  },
  /*
  apollo: {
    resumenConceptosPorNivel: {
      query: RESUMEN_CONCEPTOS_PORNIVEL,
      fetchPolicy: 'network-only',
      skip() {
        return !this.contrato?.id || !this.estimacion?.id;
      },
      variables() {
        return {
          idContrato: this.contrato.id,
          idEstimacion: this.estimacion.id,
        };
      },
    },
  }, */
  computed: {
    getFirmasActualizadas() {
      const encabezadoReferencia = this
        .mixGeneraEncabezadosPdf(`${this.estimacion.fechaPresentacion} 00:00:0`, this.firmas);
      return encabezadoReferencia.firmas;
    },
    /*
    getResumenConceptosPorNivel() {
      if (!this.resumenConceptosPorNivel) return [];
      const filtrado = this.resumenConceptosPorNivel
        .filter((c) => c.numeroNivel === 0 || c.numeroNivel === 1)
        .sort((a, b) => a.orden - b.orden);
      // return Array.from({ length: 10 }, () => filtrado).flat();
      return filtrado;
    }, */
  },
  /*
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdf() {
      this.$emit('generando');
      const contratoConFormato = this.formatoObjeto(this.contrato);
      const estimacionConFormato = this.formatoObjeto(this.estimacion);
      const listadoConcentradoConFormato = this.formatoObjeto(this.listadoConcentrado);
      const supervisor = this.getSupervisorEnConcentrado || '';
      const supervisionExterna = this.getContratoSupervisionExternaEnConcentrado
        ?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const firmasFuncionarios = this.firmas;
      const fechaActual = this.formatoFechaActual();
      let nombreTemplate = 'templateConcentrado';
      if (this.contrato.esObraFinanciada) { nombreTemplate = 'templateConcentradoOPF'; }
      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato: contratoConFormato,
          estimacion: estimacionConFormato,
          trabajos: listadoConcentradoConFormato,
          supervisor,
          supervisionExterna,
          firmas: firmasFuncionarios,
          fechaActual,
          footer: '',
        },
      }, `${this.contrato.numero}_Concentrado_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    conceptosConLosExcedentes() {
      return this.estimacion
        .conceptos
        .map((concepto) => {
          let existeExcedente = false;
          const { cantidad } = concepto;
          const cantidadContratada = concepto.concepto.cantidad;
          const cantidadEstimada = this.$numberRoundDigits(concepto.concepto.estimado
            .filter((estimado) => estimado.estimacion.numero < this.estimacion.numero)
            .reduce((v, estimacion) => v + (estimacion.cantidad), 0), 5);
          const cantidadEstimadaActual = cantidadEstimada + cantidad;
          let cantidadExcedente = 0;
          let importeExcedente = 0;

          if (cantidadContratada > 0 && cantidadEstimadaActual > cantidadContratada) {
            existeExcedente = true;
            const diferencia = cantidadEstimadaActual - cantidadContratada;
            cantidadExcedente = diferencia;

            if (diferencia > cantidad) {
              cantidadExcedente = cantidad;
            }

            importeExcedente = this.$numberRound((
              cantidadExcedente * concepto.concepto.precioUnitario));
          }

          return {
            ...concepto,
            cantidadExcedente,
            importeExcedente,
            existeExcedente,
          };
        });
    },
    listadoConcentrado() {
      if (!this.conceptosConLosExcedentes) return [];
      // Listado de conceptos normales
      const conceptosNormales = this.conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad > 0);
      // Listado de conceptos con excedente
      const conceptosConExcedentes = this.conceptosConLosExcedentes
        .filter((concepto) => concepto.existeExcedente === true);
      // Listado de conceptos FPs
      const conceptosFps = this.conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad === 0);

      // Regresar el listado
      return [
        {
          orden: 1,
          concepto: 'OBRA NORMAL',
          importe: (this.$ObjSumar(conceptosNormales, 'importe')
          - this.$ObjSumar(conceptosConExcedentes, 'importeExcedente')),
          observaciones: '',
        },
        {
          orden: 2,
          concepto: 'OBRA EXCEDENTE',
          importe: this.$ObjSumar(conceptosConExcedentes, 'importeExcedente'),
          observaciones: '',
        },
        {
          orden: 3,
          concepto: 'OBRA FUERA DE PRESUPUESTO',
          importe: this.$ObjSumar(conceptosFps, 'importe'),
          observaciones: '',
        },
      ].filter((concepto) => concepto.importe > 0 || concepto.importe < 0);
    },
    getSupervisorEnConcentrado() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExternaEnConcentrado() {
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
  }, */
  watch: {
    estimacion: {
      immediate: true, // también corre al montar
      handler(nuevaEstimacion) {
        if (!nuevaEstimacion?.id) return;

        this.listadoDetalleConcentrado = [];
        this.getDatosResumenConceptosPorNivel(nuevaEstimacion);
      },
    },
  },

};
</script>

<style lang="scss" scoped>
@media print {
  @page {
    size: landscape;
    margin: 0;
  }
}
</style>
